module.exports = __webpack_public_path__ + "static/media/maleSuggestion.37160208.png";